export default __webpack_public_path__ + "c58298e558821dfe460bf9a8477fb732.png";